module.exports = __webpack_public_path__ + "static/media/image (4).96e1ed7e.jpg";